import { ReactNode } from 'react'

import { StyledTypography } from './styles'
import { Stylable } from 'utils/types'

export interface Props extends Stylable {
  children: ReactNode
  variant?:
    | 'title'
    | 'title2'
    | 'subtitle1'
    | 'subtitle2'
    | 'label1'
    | 'label2'
    | 'description'
    | 'body'
    | 'caption'
    | 'caption2'
  fontWeight?: 'bold' | 'medium' | 'regular' | 'light' | 'semiBold'
  color?: 'primary' | 'secondary' | 'danger' | 'warning' | 'success'
  fontFamily?: 'manrope' | 'inconsolata'
}

export const Typography = ({
  children,
  variant = 'title',
  fontWeight = 'regular',
  color = 'primary',
  fontFamily = 'manrope',
  style,
  className,
}: Props) => {
  return (
    <StyledTypography
      variant={variant}
      fontWeight={fontWeight}
      color={color}
      fontFamily={fontFamily}
      style={style}
      className={className}
    >
      {children}
    </StyledTypography>
  )
}
